import styled from "styled-components"

export const ContactWrapper = styled.section`
  position: relative;
  background-color: var(--white);

  .cen {
    margin-bottom: 40px;
    font-size: 12px;
    color: var(--secondaryColor);
  }

  .make-cen {
    display: flex;
    justify-content: center;
    color: var(--secondaryColor);
    font-size: 17px;
    font-weight: 400;
    line-height: 20px;
    font-family: "Oswald", sans-serif;
  }

  .hour {
    text-align: center;
    color: var(--secondaryColor);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
`

export const FirstDiv = styled.div`
  margin: 30px 0 10px 0;
  display: flex;
  justify-content: center;
  line-height: 19px;

  @media (max-width: 992px) {
    display: block;
  }

  a {
    color: var(--black);
  }

  > div {
    padding: 0 20px;
    @media (max-width: 992px) {
      padding: 5px 0;
      display: flex;
      justify-content: center;
    }
  }
`

export const ContactFormContent = styled.form`
  font-size: var(--fontSizeThree);
  display: block;
  color: var(--black);

  input,
  textarea {
    font-family: "Lato", Sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    border: 1px solid #e2e2e2;
    box-shadow: none;
    outline: none;
    transition: 0.15s;
    padding: 10px 13px 9px 13px;
    margin: 1rem 0;
    border-radius: 6px;
  }

  textarea {
    width: 100%;
  }

  .up-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 30px;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      grid-column-gap: 0px;
      grid-row-gap: 00px;
    }
  }

  .submit {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
`
